var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpVideoCarousel'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const carouselEl = widget.querySelector(".splide");
        if (!carouselEl) return;

        carousel(carouselEl);
    }

    const carousel = (carouselEl) => {
        const splideOptions = {
            type: "loop",
            focus: "center",
            pagination: false,
            perPage: 1,
            breakpoints: {
                991: {
                    padding: { left: '5%', right: '5%' },
                },
            }
        };

        App.Helpers.splideFallback(
            carouselEl,
            splideOptions,
            (splide) => {
                splideEventBindings(splide, carouselEl);
            }
        );
    };

    const splideEventBindings = (splide, carouselEl) => {

        splide.on('mounted', () => {
            splideEventBindingArrows(carouselEl);
            window.addEventListener("resize", () => splideEventBindingArrows(carouselEl));
        });

        splide.on('move', (newIndex, prevIndex) => {
            const slideNew = splide.Components.Slides.getAt(newIndex).slide;
            const slideOld = splide.Components.Slides.getAt(prevIndex).slide;
            slideNew.classList.add("is-active");
            slideOld.classList.remove("is-active");

            const iframes = carouselEl.querySelectorAll(".cmp--multiMedia__video iframe");
            iframes.forEach(iframe => {
                const multiMedia = iframe.closest(".cmp--multiMedia__video");
                if (multiMedia) {
                    App.CmpMultiMedia.stop(multiMedia);
                }
            });
        });
    };

    const splideEventBindingArrows = (carouselEl) => {

        const bps = ["lg", "xl", "xxl"];
        const media = carouselEl.querySelector(".cmp--multiMedia .cmp--multiMedia__media");
        const arrows = carouselEl.querySelectorAll("[class^='splide__arrow']");

        if (!media) return;

        if (bps.includes(App.ZagBreakpoints.getBreakpoint())) {
            const top = media.offsetHeight / 2;
            arrows.forEach(el => {
                el.style.top = `${top}px`;
            });
        } else {
            arrows.forEach(el => {
                el.style.top = "";
            });
        }
    }

    return {
        initialize
    };

})();